import type { ReactNode } from 'react';

import {
  CommentActions,
  CommentAuthor,
  CommentAuthorName,
  CommentAuthorTime,
  CommentAvatar,
  CommentBody,
  CommentDetail,
  CommentInner,
} from './Comments.style';

type Props = {
  actions?: ReactNode[];
  author?: ReactNode;
  avatar?: ReactNode;
  className?: string;
  content: ReactNode;
  datetime?: ReactNode;
};

// antd 5 removed Comment; this keeps the v4 layout for the props the comment list uses.
const Comment = ({ actions, author, avatar, className, content, datetime }: Props) => (
  <div className={className}>
    <CommentInner>
      {avatar && <CommentAvatar>{avatar}</CommentAvatar>}
      <CommentBody>
        {(author || datetime) && (
          <CommentAuthor>
            {author && <CommentAuthorName>{author}</CommentAuthorName>}
            {datetime && <CommentAuthorTime>{datetime}</CommentAuthorTime>}
          </CommentAuthor>
        )}
        <CommentDetail>{content}</CommentDetail>
        {actions?.length ? (
          <CommentActions>
            {actions.map((action, index) => (
              <li key={index}>{action}</li>
            ))}
          </CommentActions>
        ) : null}
      </CommentBody>
    </CommentInner>
  </div>
);

export default Comment;
